<!--账龄设置-->
<template>
  <div>
    <el-form ref="form1">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title" style="width: 1160px;display: inline-block;">
        <span class="titlecolor"><span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(0)" v-if="!showPriceSet">选择商品</span>
          <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodCategorySel">选择类别</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="商品名称"
                align="left"
                header-align="center" v-if="!showPriceSet">
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="商品类别"
                align="left"
                header-align="center"
                width="170">
                <template slot-scope="scope">
                  {{!scope.row.seedcode?scope.row.categorycode+' '+scope.row.categoryname:scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column label="账期(月份)" align="center" width="100" v-if="!showPriceSet">
                <template slot-scope="scope">
                  <el-input-number :min="0" :size="'mini'" :precision="0" v-model="scope.row.age"
                                   :controls="false"
                                   style="width:80px;"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="客户类型" align="center" width="200" v-if="showPriceSet">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.age" placeholder="请选择">
                    <el-option
                      v-for="item in parameterData"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <a size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row,0)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2" v-if="!showPriceSet&&tableData.length>0">
          <template slot="title" style="width: 1160px;display: inline-block;">
        <span class="titlecolor">请添加不计算账期的商品
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(1)">选择商品</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableDataSkim"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="产品类别"
                align="left"
                header-align="center"
                width="170">
                <template slot-scope="scope">
                  {{scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="产品名称"
                align="left"
                header-align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <a
                    size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row,1)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <JxcgooddetailSel ref="JxcgooddetailSel" :isShowCheckBox="true"
                      @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <JxcgoodscategorySel ref="JxcgoodscategorySel" :isShowCheckBox="true"
                         @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
  </div>
</template>
<script>
  import {saveData, getListData} from '@/api/set/accountageset';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel'
  import JxcgoodscategorySel from '../../set/jxcgoodscategory/JxcgoodscategorySel'
  export default {
    name: "AccountAgeEdit",
    data() {
      return {
        dialogFormVisible: false,
        activeNames: ['1', '2'],
        tableData: [],
        tableDataSkim: [],//撇除的产品
        delUnitguids: [],
        loading: false,//控制按钮显示
        formLabelWidth: '120px',
        isSkim: 0,//1表示添加撇除产品
        userInfoModel: {},//缓存数据
        tokenModel: {},
        cusSerial:'',
      }
    },
    props: {
      customerserial:{
        default: ""
      },
      showPriceSet:{
        default:false
      },
      parameterData:{
        default: []
      },
    },
    methods: {
      //删除明细
      handleDelete(index, row, isSkim) {
        if (isSkim == 1) {
          this.tableDataSkim.splice(index, 1)
        } else {
          //如果删除的是类别，则要判断此类别下面是否有特价商品，如果有，则必须先删除特价商品才能删除此类别
          if (!row.seedcode) {
            for (let i in this.tableDataSkim) {
              if (this.tableDataSkim[i].categorycode.startsWith(row.categorycode)) {
                this.$message({
                  message: "该类别下存在排除的商品，无法删除该类别",
                  type: 'warning',
                  duration: 1500
                })
                return
              }
            }
          }
          this.tableData.splice(index, 1)
        }
        if (row.unitguid) {
          this.delUnitguids.push(row.unitguid)
        }
      },
      //显示商品选择页面
      showGoodDetailSel(isSkim) {
        this.isSkim = isSkim
        this.$refs.JxcgooddetailSel.show()
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        if (this.isSkim == 1) {
          this.afterSelectSkim(arr)
          return
        }
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if ((!this.tableData[j].seedcode && arr[i].categorycode.startsWith(this.tableData[j].categorycode)) || (this.tableData[j].seedcode && this.tableData[j].seedcode == arr[i].seedcode
            )) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              categoryname: arr[i].lname,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              categorycode: arr[i].categorycode, setmethod: this.showPriceSet?1:0
            })
          }
        }
        if (count > 0) {
          this.$message({
            message: "商品已存在，或者属于已选择类别下的商品",
            type: 'info',
            duration: 1500
          })
        }

      },
      //选择特价商品之后执行
      afterSelectSkim(arr) {
        let count = 0;
        let i = this.tableDataSkim.length
        label1:
          for (let i in arr) {
            let biaoji = 0
            for (let j in this.tableDataSkim) {
              //判读该特价商品是否已经添加
              if (this.tableDataSkim[j].seedcode == arr[i].seedcode) {
                biaoji = 1
                count++
                continue label1
              }
            }

            if (biaoji == 0) {
              //判断该特价商品不能是明细中的商品
              for (let g in this.tableData) {
                if (this.tableData[g].seedcode && arr[i].seedcode == this.tableData[g].seedcode) {
                  biaoji = 1
                  count++
                  continue label1
                }
              }
            }

            if (biaoji == 0) {
              let temp = 0
              for (let g in this.tableData) {
                //判读特价的商品必须属于明细下的类别
                if (!this.tableData[g].seedcode && arr[i].categorycode.startsWith(this.tableData[g].categorycode)) {
                  temp = 1
                  this.tableDataSkim.push({
                    isskim: 1,
                    categoryname: arr[i].lname,
                    seedcode: arr[i].seedcode,
                    seedname: arr[i].seedname,
                    categorycode: arr[i].categorycode,
                    setmethod:this.showPriceSet?1:0
                  })
                  break
                }
              }
              if (temp == 0) {
                count++
              }
            }
          }
        if (count > 0) {
          this.$message({
            message: "该排除商品已存在，或者明细中已存在，或者不属于明细类别下的商品",
            type: 'info',
            duration: 1500
          })
        }
      },
      //选择商品类别
      showGoodCategorySel(arr) {
        this.$refs.JxcgoodscategorySel.show()
      },
      //选择商品类别后执行
      afterSelectCategoryCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            if ((!this.tableData[j].seedcode && (arr[i].categorycode.startsWith(this.tableData[j].categorycode) || this.tableData[j].categorycode.startsWith(arr[i].categorycode)) && arr[i].categorycode != this.tableData[j].categorycode) || (this.tableData[j].seedcode && this.tableData[j].categorycode.startsWith(arr[i].categorycode))) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({categorycode: arr[i].categorycode, categoryname: arr[i].categoryname,setmethod:this.showPriceSet?1:0})
          }
        }
        if (count > 0) {
          this.$message({
            message: "该商品类别已经存在父类别、子类别或该类别下的商品",
            type: 'info',
            duration: 1500
          })
        }
      },
      checkData(alertinfo){
        for(let i in this.tableData){
          if(!this.tableData[i].age){
            this.$message({
              message: alertinfo,
              type: 'error',
              duration: 1500
            })
            return false
          }
        }
        return true;
      },
      //保存
      saveData(serial) {
        this.loading = true
        let data1 = {
          customerserial: serial,
          detail: JSON.stringify(this.tableData.concat(this.tableDataSkim)),
          delunitguids: JSON.stringify(this.delUnitguids)
        }
        saveData(data1).then(response => {
          if (response.data.code == 0) {
            // this.$message({
            //   message: '保存成功',
            //   type: 'success',
            //   duration: 1500
            // })
            // this.dialogFormVisible = false;
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.refreshBtn()
          }
        });

      },
      //刷新按钮
      refreshBtn() {
        this.loading = false
      },
      //绑定查看数据
      initData(cusser) {
        this.initForm()
        this.dialogFormVisible = true
        if(cusser)
          this.cusSerial=cusser;
        else
          this.cusSerial=this.customerserial;
        if (this.cusSerial == '') {
          this.tableData.splice(0, this.tableData.length);
          this.tableDataSkim.splice(0, this.tableDataSkim.length);
        } else {
          getListData({customerserial: this.cusSerial, setmethod: this.showPriceSet ? 1 : 0}).then(response => {
            //明细
            response.data.obj.forEach(o => {
              o.age=o.age.toString();
              if (o.isskim == 1) {
                this.tableDataSkim.push(o)
              } else {
                this.tableData.push(o)
              }
            })
          });
        }
      },
      //初始化
      initForm() {
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
        }
        this.refreshBtn()
        this.tableData = []
        this.tableDataSkim = []
        this.delUnitguids = []
      },

    },


    mounted() {
      this.tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.financeright = this.$checkRight('财务')
      this.initData();
    },
    components: {
      JxcgooddetailSel,
      JxcgoodscategorySel,
    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/AccountAgeEdit.vue